import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/header.png'
import _imports_1 from '@/assets/ar.svg'
import _imports_2 from '@/assets/us.svg'


const _hoisted_1 = { class: "flex flex-col items-center justify-center bg-white" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex justify-center space-x-4 py-4 bg-gray-100" }
const _hoisted_4 = { class: "font-semibold ml-2" }
const _hoisted_5 = { class: "font-semibold ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "w-full h-1",
        style: {"background-color":"#3c3c3a"}
      }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "py-10 flex flex-col items-center max-h-full" }, [
        _createElementVNode("img", {
          class: "w-7/12",
          src: _imports_0
        })
      ], -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "w-full h-1",
        style: {"background-color":"#3c3c3a"}
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('es'))),
          href: "#",
          class: "flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: _imports_1,
            class: "h-8 rounded-full"
          }, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('menu.español')), 1)
        ]),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('en'))),
          href: "#",
          class: "flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: _imports_2,
            class: "h-8 rounded-full"
          }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('menu.ingles')), 1)
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "w-full h-1",
        style: {"background-color":"#3c3c3a"}
      }, null, -1))
    ])
  ]))
}